import { put, select, takeLatest } from 'redux-saga/effects'

// @ts-ignore
import * as actions from 'store/entities/organizations/actions'
// @ts-ignore
import * as selectors from 'store/entities/organizations/selectors'
// @ts-ignore
import { FIRSTNAME, FULLNAME } from 'app/constants/organizations'
import { IFetchUsersPayload } from 'store/entities/organizations/interface'

export default function* fetchUsersSaga() {
  // @ts-ignore
  yield takeLatest(actions.fetchUsersTrigger.toString(), handleFetchUsersSaga)
}

export function* handleFetchUsersSaga({ payload: { params } }: IFetchUsersPayload) {
  const id = params.id ? params.id : yield select(selectors.getOrganizationUsersOrganizationId)
  const page = typeof params.page === 'number' ? params.page : yield select(selectors.getOrganizationUsersCurrentPage)
  const limit = params.limit ? params.limit : yield select(selectors.getOrganizationUsersPerPage)
  const sortBy = params.by ? params.by : yield select(selectors.getOrganizationUsersSortBy)
  const sort = sortBy === FULLNAME ? FIRSTNAME : sortBy
  const desc = params.desc ? +params.desc : +(yield select(selectors.getOrganizationUsersSortDesc))
  const team = params.team ? params.team : yield select(selectors.getOrganizationUsersFilterByTeam)
  const search = params.search ? params.search : yield select(selectors.getOrganizationUsersFilterBy)
  // slice(0, -1) for delete plurals at tab name
  const role = params.role ? params.role.slice(0, -1) : (yield select(selectors.getOrganizationUsersTab)).slice(0, -1)
  const filterType = params.filterType ? params.filterType : yield select(selectors.getOrganizationUsersFilter)
  try {
    yield put(actions.fetchUsers({ id, page, limit, sort, desc, team, search, role, filterType }))
  } catch (badResponse) {
    console.log(badResponse)
  }
}
